module.exports = __webpack_public_path__ + "static/2-4e03987a958f1747685a67ba5f1f763a.jpg";